export const FETCH_ENGLISH_AUCTION_HEADER_DATA_REQUEST = 'FETCH_ENGLISH_AUCTION_HEADER_DATA_REQUEST';
export const FETCH_ENGLISH_AUCTION_HEADER_DATA_SUCCESS = 'FETCH_ENGLISH_AUCTION_HEADER_DATA_SUCCESS';
export const FETCH_ENGLISH_AUCTION_HEADER_DATA_FAILURE = 'FETCH_ENGLISH_AUCTION_HEADER_DATA_FAILURE';

export const VIEW_USER_WISE_LIVE_ENGLISH_AUCTION_REQUEST = 'VIEW_USER_WISE_LIVE_ENGLISH_AUCTION_REQUEST';
export const VIEW_USER_WISE_LIVE_ENGLISH_AUCTION_SUCCESS = 'VIEW_USER_WISE_LIVE_ENGLISH_AUCTION_SUCCESS';
export const VIEW_USER_WISE_LIVE_ENGLISH_AUCTION_FAILURE = 'VIEW_USER_WISE_LIVE_ENGLISH_AUCTION_FAILURE';

// actions.js
export const FETCH_DEFAULT_COLUMN_CONFIG_REQUEST = 'FETCH_DEFAULT_COLUMN_CONFIG_REQUEST';
export const FETCH_DEFAULT_COLUMN_CONFIG_SUCCESS = 'FETCH_DEFAULT_COLUMN_CONFIG_SUCCESS';
export const FETCH_DEFAULT_COLUMN_CONFIG_FAILURE = 'FETCH_DEFAULT_COLUMN_CONFIG_FAILURE';


export const ENGLISH_CATELOG_FETCH_ALL_DATA = "ENGLISH_CATELOG_FETCH_ALL_DATA";
export const ENGLISH_CATELOG_FETCH_ALL_DATA_SUCCESS = "ENGLISH_CATELOG_FETCH_ALL_DATA_SUCCESS";
export const ENGLISH_CATELOG_FETCH_ALL_DATA_FAILURE = "ENGLISH_CATELOG_FETCH_ALL_DATA_FAILURE";

// Save Column Config

export const ADD_CATALOG_COLUMN_CONFIG_REQUEST = 'ADD_CATALOG_COLUMN_CONFIG_REQUEST';
export const ADD_CATALOG_COLUMN_CONFIG_SUCCESS = 'ADD_CATALOG_COLUMN_CONFIG_SUCCESS';
export const ADD_CATALOG_COLUMN_CONFIG_FAILURE = 'ADD_CATALOG_COLUMN_CONFIG_FAILURE';

export const FETCH_ENGLISH_AUCTION_CENTER_DATA_API_CALL = 'FETCH_ENGLISH_AUCTION_CENTER_DATA_API_CALL';

//Bid
export const LOT_WISE_BID_ACCEPT_REQUEST = 'LOT_WISE_BID_ACCEPT_REQUEST';
export const LOT_WISE_BID_ACCEPT_SUCCESS = 'LOT_WISE_BID_ACCEPT_SUCCESS';
export const LOT_WISE_BID_ACCEPT_FAILURE = 'LOT_WISE_BID_ACCEPT_FAILURE';

export const FETCH_REMAINING_TIME_REQUEST = 'FETCH_REMAINING_TIME_REQUEST';
export const FETCH_REMAINING_TIME_SUCCESS = 'FETCH_REMAINING_TIME_SUCCESS';
export const FETCH_REMAINING_TIME_FAILURE = 'FETCH_REMAINING_TIME_FAILURE';

// BidBook

export const FETCH_BID_BOOK_REQUEST = 'FETCH_BID_BOOK_REQUEST';
export const FETCH_BID_BOOK_SUCCESS = 'FETCH_BID_BOOK_SUCCESS';
export const FETCH_BID_BOOK_FAILURE = 'FETCH_BID_BOOK_FAILURE';

export const FETCH_SESSION_TIME_REQUEST = 'FETCH_SESSION_TIME_REQUEST';
export const FETCH_SESSION_TIME_SUCCESS = 'FETCH_SESSION_TIME_SUCCESS';
export const FETCH_SESSION_TIME_FAILURE = 'FETCH_SESSION_TIME_FAILURE';

export const FETCH_LOT_REQUEST = 'FETCH_LOT_REQUEST';
export const FETCH_LOT_SUCCESS = 'FETCH_LOT_SUCCESS';
export const FETCH_LOT_FAILURE = 'FETCH_LOT_FAILURE';

export const FETCH_BID_BOOK_SEARCH_DROPDOWN_DATA_REQUEST = 'FETCH_BID_BOOK_SEARCH_DROPDOWN_DATA_REQUEST';
export const FETCH_BID_BOOK_SEARCH_DROPDOWN_DATA_SUCCESS = 'FETCH_BID_BOOK_SEARCH_DROPDOWN_DATA_SUCCESS';
export const FETCH_BID_BOOK_SEARCH_DROPDOWN_DATA_FAILURE = 'FETCH_BID_BOOK_SEARCH_DROPDOWN_DATA_FAILURE';


export const FETCH_BID_BOOK_EXPORT_SUCCESS = 'FETCH_BID_BOOK_EXPORT_SUCCESS';
export const FETCH_BID_BOOK_EXPORT_FAILURE = 'FETCH_BID_BOOK_EXPORT_FAILURE';
// BidBook End

export const VIEW_BID_REQUEST = 'VIEW_BID_REQUEST';
export const VIEW_BID_SUCCESS = 'VIEW_BID_SUCCESS';
export const VIEW_BID_FAILURE = 'VIEW_BID_FAILURE';

// actionTypes.js
export const ADD_CATALOG_COLUMN_CONFIG_INITIATE = 'ADD_CATALOG_COLUMN_CONFIG_INITIATE';
export const ADD_CATALOG_COLUMN_CONFIG_COMPLETE = 'ADD_CATALOG_COLUMN_CONFIG_COMPLETE';
export const ADD_CATALOG_COLUMN_CONFIG_ERROR = 'ADD_CATALOG_COLUMN_CONFIG_ERROR';
